// Arabic resource bundle — PLACEHOLDER STRUCTURE ONLY.
//
// Every value below is intentionally left as null (marked as `pending`) so
// that missing keys fall back to English at runtime. Drop real Arabic copy
// into individual values as it is delivered — do not machine-translate.
//
// The shape of this object mirrors /src/i18n/en/common.js exactly. Any
// deviation from that shape means a key will fall back to English silently,
// which is the intended behaviour while translation is in progress.
export const ar = {
  brand: {
    name: null,      // pending: brand name in Arabic (typically "وفاء سولوشنز")
    tagline: null,   // pending
  },
  nav: {
    whoWeServe: null,
    services: "الخدمات",
    solutions: "الحلول",
    products: "المنتجات",
    meyar: "Meyar",
    work: "الأعمال",
    tools: null,
    company: "الشركة",
    getQuote: null,
  },
  contact: {
    email: "support@wafa.om",  // email addresses do not translate
  },
  announcement: {
    text: null,
    cta: null,
  },
};
